var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectAllStatic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "select-all-static"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 139",
    cx: 7.02578,
    cy: 7.81435,
    r: 2.97216,
    fill: "#4DBD94",
    fillOpacity: 0.3,
    stroke: "#4DBD94",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 141",
    cx: 7.02578,
    cy: 17.7731,
    r: 2.97216,
    fill: "#4DBD94",
    fillOpacity: 0.3,
    stroke: "#4DBD94",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 140",
    cx: 17.0567,
    cy: 7.81435,
    r: 2.97216,
    fill: "#4DBD94",
    fillOpacity: 0.3,
    stroke: "#4DBD94",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 186",
    x: 15.6447,
    y: 19.6855,
    width: 5.79643,
    height: 1.648,
    rx: 0.823999,
    transform: "rotate(-50.0715 15.6447 19.6855)",
    fill: "#4DBD94"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 187",
    x: 14.8329,
    y: 17.0344,
    width: 3.90535,
    height: 1.648,
    rx: 0.823999,
    transform: "rotate(38.3307 14.8329 17.0344)",
    fill: "#4DBD94"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectAllStatic);
export default __webpack_public_path__ + "static/media/select-all-static.6fb177eb9b535fc410052f661c2f4e29.svg";
export { ForwardRef as ReactComponent };